import { render, staticRenderFns } from "./SelectPosModel.vue?vue&type=template&id=78065c20&scoped=true"
import script from "./SelectPosModel.vue?vue&type=script&lang=js"
export * from "./SelectPosModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78065c20",
  null
  
)

export default component.exports